"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const definables_1 = __importDefault(require("../../maps/definables"));
const getDefinables = (className) => {
    const map = definables_1.default.get(className);
    if (typeof map !== "undefined") {
        return map;
    }
    return new Map;
};
exports.default = getDefinables;
